import momentoriginal from "moment";

export const moment = (val: Date | undefined | null, format = "DD.MM.YYYY") => {
    if (val === undefined || val === null) {
        return "";
    }
    return momentoriginal(val).format(format);
};
